/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Optimization_Target_RequiredInputs */

const en_us2_optimization_target_required = /** @type {(inputs: Optimization_Target_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select an Optimization Target`)
};

const en_gb2_optimization_target_required = /** @type {(inputs: Optimization_Target_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select an Optimisation Target`)
};

/**
* | output |
* | --- |
* | "Please select an Optimization Target" |
*
* @param {Optimization_Target_RequiredInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const optimization_target_required = /** @type {((inputs?: Optimization_Target_RequiredInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Optimization_Target_RequiredInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_optimization_target_required(inputs)
	return en_us2_optimization_target_required(inputs)
});